import NamedDto from 'modules/base/dto/NamedDto';
import { convertStringToDate } from 'modules/base/utils/ConversionUtil';

export default class NotificationTableDto extends NamedDto {
	constructor() {
		super();

		/** @type {Date} */
		this.created = null;

		/** @type {string} */
		this.message = null;

		/** @type {string} */
		this.notificationType = null;

		/** @type {string} */
		this.severity = null;

		/** @type {boolean} */
		this.read = null;

		/** @type {Object} */
		this.data = null;
	}

	/**
	 * @typedef {Object} _NotificationTableDtoProps
	 * @property {Date} created
	 * @property {string} message
	 * @property {string} notificationType
	 * @property {string} severity
	 * @property {boolean} read
	 * @property {Object} data
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _NotificationTableDtoProps} NotificationTableDtoProps
	 */

	/**
	 * @param {NotificationTableDtoProps} props
	 * @returns {NotificationTableDto}
	 */
	setup(props) {
		super.setup(props);

		this.created = props.created != null ? convertStringToDate(props.created) : null;
		this.message = props.message;
		this.notificationType = props.notificationType;
		this.severity = props.severity;
		this.read = !!props.read;
		this.data = props.data;

		return this;
	}
}
